import { requestInFlatStatuses } from './common';
import { requestInFlatStagesColorsMap } from './stagesColorMaps';
import { texts } from './texts';

const { immediate, debt, active, comment } = requestInFlatStatuses;

export const requestInFlatIndicators = [
  {
    id: immediate,
    value: texts.immediateRequest,
    bg: requestInFlatStagesColorsMap.get(immediate),
  },
  {
    id: debt,
    value: texts.debt,
    bg: requestInFlatStagesColorsMap.get(debt),
  },
  {
    id: active,
    value: texts.activeRequest,
    bg: requestInFlatStagesColorsMap.get(active),
  },
  {
    id: comment,
    value: texts.comment,
    bg: requestInFlatStagesColorsMap.get(comment),
  },
];
